import { render, staticRenderFns } from "./language-list.vue?vue&type=template&id=6d28652a&"
import script from "./language-list.vue?vue&type=script&lang=js&"
export * from "./language-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports